import React, { useRef } from 'react';
import { Box, DropContent, useClickOutside } from '@common-fe/common-fe';

import { Option } from '@/modules/core/components/Menu/menu.types';

import MobileSidebarOptionDropdownItem from './MobileSidebarOptionDropdownItem';

interface MobileSidebarOptionDropdownProps {
  testId?: string;
  dropdownOptions?: Option[];
  isDropdownVisible?: boolean;
  setIsDropdownVisible?: (value: boolean) => void;
  onPick: (url?: string) => void;
  children?: React.ReactNode;
}

const MobileSidebarOptionDropdown: React.FC<MobileSidebarOptionDropdownProps> = ({
  testId,
  dropdownOptions,
  isDropdownVisible,
  setIsDropdownVisible,
  onPick,
  children,
}) => {
  const ref = useRef(null);
  useClickOutside(ref, () => setIsDropdownVisible?.(false));
  
  return (
    <DropContent
      ref={ref}
      testId={testId}
      visible={isDropdownVisible}
      contentWidth="245px"
      rightAlign
      trianglePosition="right"
      bottomMode
      content={(
        <Box gap="spacing8">
          {dropdownOptions?.map((dropdownOption) => (
            <MobileSidebarOptionDropdownItem
              {...dropdownOption}
              testId={dropdownOption?.key}
              onPick={onPick}
              setIsDropdownVisible={setIsDropdownVisible}
              key={dropdownOption?.key}
            />
          ))}
        </Box>
      )}
    >
      {children}
    </DropContent>
  );
};
  

export default MobileSidebarOptionDropdown;
